<template>
    <div class="subtitle informatiza-aps">
        <div class="subtitle-item">
            <input type="checkbox" name="" v-model="reds" @change="onChangeReds($event)">
            <span style="background-color: red"></span> < Parâmetro 
            <span v-b-tooltip.hover title="Não atingiu ainda a quantidade mínima de atendimentos no mês atual para manter o Informatiza APS da equipe" class="icon-tooltip">
                <i class="icofont-info-circle"></i>
            </span>   
        </div>
        <div class="subtitle-item">
            <input type="checkbox" name="" v-model="greens" @change="onChangeGreens($event)">
            <span style="background-color: green"></span> >= Parâmetro
            <span v-b-tooltip.hover title="Atingiu a quantidade mínima de atendimentos no mês atual para manter o Informatiza APS da equipe" class="icon-tooltip">
                <i class="icofont-info-circle"></i>
            </span>   
        </div>
    </div>
</template>

<script>
export default {
    name: "Subtitle",
    props:{
        items:{
            type: Array,
            default: () => {}
        }
    },
    data(){
        return{
            reds: false,
            greens: false
        }
    },
    methods:{
        onChangeReds(event){
            this.greens = false
            this.$emit('exibirVermelhos', event.target.checked)
        },
        onChangeGreens(event){
            this.reds = false
            this.$emit('exibirVerdes', event.target.checked)
        }
    }
}
</script>

<style>
 .subtitle.informatiza-aps{
     display: flex;
    align-items: center;
    justify-content: flex-start;
 }
 .informatiza-aps .subtitle-item{
    font-size: 13px;
 }
 .subtitle-item span{
    width: 15px;
    height: 15px;
    display: inline-block;
    vertical-align: middle;
 }

 .subtitle-item span i {
    font-size: 14px;
    vertical-align: top;
}

.subtitle .subtitle-item input[type='checkbox']{
    display: inline-block;
    margin: 0 10px;
    vertical-align: middle;
}

 /* 
  ##Device = Most of the Smartphones Mobiles (Portrait)
  ##Screen = B/w 320px to 479px
*/

@media (min-width: 320px) and (max-width: 480px) {
    .subtitle{
        justify-content: flex-start;
    }
    .subtitle-item {
        font-size: 13px;
    }
}

/* 
  ##Device = Tablets, Ipads (portrait)
  ##Screen = B/w 768px to 1024px
*/

@media (min-width: 768px) and (max-width: 1024px) {
    .subtitle{
        justify-content: flex-start;
    }
    .subtitle-item {
        font-size: 13px;
    }
}
</style>
